'use strict';

var measure = require('../../projection/utils/measure.cjs');
var DOMVisualElement = require('../dom/DOMVisualElement.cjs');
var buildStyles = require('./utils/build-styles.cjs');
var render = require('./utils/render.cjs');
var scrapeMotionValues = require('./utils/scrape-motion-values.cjs');
var keysTransform = require('../../../../../../../motion-dom/dist/es/render/utils/keys-transform.cjs');
var parseTransform = require('../../../../../../../motion-dom/dist/es/render/dom/parse-transform.cjs');
var isCssVariable = require('../../../../../../../motion-dom/dist/es/animation/utils/is-css-variable.cjs');

function getComputedStyle(element) {
    return window.getComputedStyle(element);
}
class HTMLVisualElement extends DOMVisualElement.DOMVisualElement {
    constructor() {
        super(...arguments);
        this.type = "html";
        this.renderInstance = render.renderHTML;
    }
    readValueFromInstance(instance, key) {
        if (keysTransform.transformProps.has(key)) {
            return this.projection?.isProjecting
                ? parseTransform.defaultTransformValue(key)
                : parseTransform.readTransformValue(instance, key);
        }
        else {
            const computedStyle = getComputedStyle(instance);
            const value = (isCssVariable.isCSSVariableName(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint }) {
        return measure.measureViewportBox(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        buildStyles.buildHTMLStyles(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return scrapeMotionValues.scrapeMotionValuesFromProps(props, prevProps, visualElement);
    }
}

exports.HTMLVisualElement = HTMLVisualElement;
exports.getComputedStyle = getComputedStyle;
//# sourceMappingURL=HTMLVisualElement.cjs.map
